/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 1 = Block 2 = Log 3 = Challenge 4 = Allow 5 = Bypass
 */
export type WafRuleActionType = 1 | 2 | 3 | 4 | 5;

export const WafRuleActionType = {
  Block: 1 as WafRuleActionType,
  Log: 2 as WafRuleActionType,
  Challenge: 3 as WafRuleActionType,
  Allow: 4 as WafRuleActionType,
  Bypass: 5 as WafRuleActionType,
};
